import Vue from 'vue'
// 引入高德地图
import VueAMap from 'vue-amap'
// 引入微信
import wx from 'weixin-js-sdk'

import api from '@/service/request/api'

import {wxShare, wxHide} from '@/utils/wxjsdk'

import * as session from '@/utils/session'

import cityCode from '@/utils/cityCode'
import Vant from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)
Vue.use(VueAMap)
Vue.use(wx)
export default {
  install (Vue, options) {
    // 全局接口
    Vue.prototype.$api = api
    // 微信jssdk
    Vue.prototype.$wxShare = wxShare
    Vue.prototype.$wxHide = wxHide
    // 其他工具方法
    Vue.prototype.$session = session
    Vue.prototype.$cityCode = cityCode
  }
}
